import React from "react";
import {ButtonLayout, NegativeButtons, PositiveButtons} from "../button/ButtonLayout";
import {CancelButton} from "../button/CancelButton";
import DialogTitle from "./DialogTitle";
import Dialog from "./Dialog";
import DialogContent from "./DialogContent";
import DialogActions from "./DialogActions";
import DialogContentText from "./DialogContentText";
import {DeleteButton} from "../button/DeleteButton";

export interface DeleteConfirmationDialogProps {
    open: boolean;
    title: string;
    confirmationText: string;
    onDelete: () => void;
    onClose: () => void;
}

export default function DeleteConfirmationDialog(props: Readonly<DeleteConfirmationDialogProps>) {

    const {open, title, confirmationText, onDelete, onClose} = props;

    return (
        <Dialog
                open={open}
                onClose={onClose} >
            <DialogTitle title={title} onDialogClosed={onClose}/>
            <DialogContent>
                <DialogContentText>
                    {confirmationText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <ButtonLayout>
                    <PositiveButtons>
                        <DeleteButton onClick={onDelete} />
                    </PositiveButtons>
                    <NegativeButtons>
                        <CancelButton onClick={onClose} />
                    </NegativeButtons>
                </ButtonLayout>
            </DialogActions>
        </Dialog>
    )
}
